import { NumberFormatBase, usePatternFormat } from "react-number-format";

const persianNumeral = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

function CustomOtpInput(props) {
  const { removeFormatting, ...rest } = usePatternFormat(props);

  const _removeFormatting = (val) => {
    const _val = val.replace(new RegExp(persianNumeral.join("|"), "g"), ($1) =>
      persianNumeral.indexOf($1)
    );
    return removeFormatting(_val);
  };

  return (
    <NumberFormatBase
      removeFormatting={_removeFormatting}
      {...rest}
      className="form-control border-secondary-subtle"
      style={{
        // fontSize: "24px",
        //letterSpacing: "4px",
        textAlign: "center",
        outline: "none",
        //borderRadius: "6px",
        direction: "ltr",
        //maxWidth: "200px",
        // border: "1px solid black"
      }}
    />
  );
}

export default CustomOtpInput;
